import superagent from 'superagent'

const userFollowing = {
  getFollowing: ({ userId, token, payLoad = {} }) => {
    // const { beforeId = '', beforePosition = '', afterPosition = '', afterId = '' } = payLoad;

    return new Promise((resolve, reject) => {
      superagent
        // .get(`${__API_URI_3__}/UserFollowing/Get/?userId=${userId}&beforeId=${beforeId}&beforePosition=${beforePosition}&afterPosition=${afterPosition}&afterId=${afterId}`)
        .get(`${__API_URI_3__}/userFollowing/getAllFollowing`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err);
          }
          resolve(res.body);
        });
    });
  },
  add: (props) => {
    const { userId, token } = props
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_3__}/UserFollowing/Follow/?followUserId=${userId}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  },
  remove: (props) => {
    const { userId, token } = props
    return new Promise((resolve, reject) => {
      superagent
        .delete(`${__API_URI_3__}/UserFollowing/Unfollow/${userId}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  },
  locationSharing: ({ userId, token, payLoad = {} }) => {
    return new Promise((resolve, reject) => {
      superagent
        // .get(`${__API_URI_3__}/UserFollowing/Get/?userId=${userId}&beforeId=${beforeId}&beforePosition=${beforePosition}&afterPosition=${afterPosition}&afterId=${afterId}`)
        .get(`${__API_URI__}/Location/GetFriendLocations`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err);
          }
          resolve(res.body);
        });
    });
  }

}

export default userFollowing
